window.addEventListener('DOMContentLoaded', () => {
    const menuTop = document.querySelector('.menu.menutop');
    // 3 level navigation functionality
    // We need two elements from the DOM, the mainMenu (to reset the navigation when popup is closed) and navClose to catch when popup is closed
    const handleNavigation = () => {
        const mainMenuNav = document.querySelector('ul.menulist[data-menu-name="main"]')
        const navClose = document.querySelector('.menu-close-icon svg');

        const navCloseClicked = (e) => {
            e.preventDefault()

            document.querySelectorAll('ul.menulist').forEach(el=>{
                el.classList.remove('active')
                el.classList.remove('last')
                el.classList.remove('children-selected')
            })
            mainMenuNav.classList.add('active');
        }

        navClose.onclick = navCloseClicked;
        menuTop.style.height =window.getComputedStyle(mainMenuNav).getPropertyValue('height')
    }
    handleNavigation()

    const imageSlider = () => {
        $('.sliderbottom').slick({
            slidesToShow: 2.3,
            slidesToScroll: 1,
            slidesPerRow: 1,
            vertical: false,
            verticalSwiping: false,
            swipeToSlide: true,
            adaptiveHeight: false,
            infinite: false,
            dots: false,
            arrows: false
        });
    }
    imageSlider()

    function navLinkClicked() {
        let link = this.children[0]
        let goto = link.getAttribute('data-goto')
        let nextMenu = document.querySelector('ul.menulist[data-menu-name="' + goto + '"]')
        let currentMenu = document.querySelector('ul.menulist.active')
        if (!currentMenu.classList.contains('last'))
            currentMenu.classList.add('children-selected');

        if (link.classList.contains('hidefixedbottom')) {
            const menubottom = document.querySelector('.menu.menubottom');
            if (!menubottom.classList.contains('hidden')) {
                menubottom.classList.add('hidden')
            }
        }

        menuTop.style.height = window.getComputedStyle(nextMenu).getPropertyValue('height')

        navigate(nextMenu, currentMenu, link);
    }

    function navBackLinkClicked(e){
        let link = e.currentTarget;
        let goto = link.getAttribute('data-back-to')
        let nextMenu = document.querySelector('ul.menulist[data-menu-name="' + goto + '"]')
        let currentMenu = document.querySelector('ul.menulist.active')

        const bottomHided = document.querySelector('.menu.menubottom.hidden');
        if (bottomHided) {
            bottomHided.classList.remove('hidden');
        }

        if (nextMenu.classList.contains('children-selected')) nextMenu.classList.remove('children-selected')


        menuTop.style.height = window.getComputedStyle(nextMenu).getPropertyValue('height')

        navigate(nextMenu, currentMenu, null)
    }

    const links = document.querySelectorAll('ul.menulist > li:not(.onelink)');
    for (let link of links) {
        link.addEventListener("click", navLinkClicked, true);
    }

    const backToLinks = document.querySelectorAll('ul.menulist > a.mobile-menu-back')
    for (let bLink of backToLinks){
        bLink.onclick = navBackLinkClicked;
    }

    const navigate = (nextMenu, currentMenu, link) => {
        if (nextMenu && currentMenu) {
            currentMenu.classList.remove('active')
            nextMenu.classList.add('active')
        } else {
            if (link) window.location = link.href
        }
    }
})